export default __webpack_public_path__ + "static/media/servicies-policies.icon.590adcca.svg";